import { createRouter, createWebHistory } from 'vue-router'
import { routes, menuRoutes } from '@/router/config'

const rs = routes.concat(menuRoutes)

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: rs
})

export default router
